const anonymize = (value, pattern, anonymize) => {
  const v = value.toString();
  return v.replace(pattern, anonymize)
}

export default anonymize;
